<template>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        :lock-scroll="true"
        width="460px"
        @closed="handleClose"
        :destroy-on-close="true"
        ref="entrance"
        class="entrance"
        >

        <!-- :close-on-click-modal="false" -->
        <el-dialog
            title="队伍报名"
            :visible.sync="inner_signup"
            width="783px"
            :destroy-on-close="true"
            append-to-body
            :close-on-click-modal="true"
            ref="inner_signup_modal"
            class="leader-form"                      
            >
            <form-leader @destory_all="destory_all" :ua="ua"></form-leader>
        </el-dialog>

        <el-dialog
            title="战队码"
            :visible.sync="inner_code"
            width="460px"
            :destroy-on-close="true"
            append-to-body
            ref="inner_code_modal"                
            >
            <code-modal @destory_all="destory_all" :ua="ua"></code-modal>
        </el-dialog>        


        <div class="enter-view">
            <div class="wrapper"></div>
            <div class="header"></div>
            <ul>
                <li><div class="u-btn leader" @click="inner_signup=true"></div></li>
                <li><div class="u-btn team-member" @click="call_code_view"></div></li>
            </ul>
        </div>
    </el-dialog>    
</template>

<script>
  //code
  import Code_Modal from '@/components/codeModal/codeModal.vue';
  //leader
  import Form_Leader from '@/components/leaderForm.vue';

  export default {
    data() {
      return {
        dialogVisible: false,
        inner_code : false,
        inner_signup : false,
        ua : () => {},
      };
    },
    components :{
        'code-modal' : Code_Modal,
        'form-leader' : Form_Leader,
    },
    methods: {
      handleClose(done) {
        this.$destroy();
      },
      call_code_view() {
          this.inner_code = true;
          //this.$refs.inner_code_modal.$refs.code_input.focus();
      },
      destory_all (arr){
          console.log(arr);
          this.inner_code = false;
          this.inner_signup = false;
          this.dialogVisible = false;
      },
      test (str){
          alert(str);
      },
    }
  };
</script>

<style scoped>

    .enter-view{
        position: relative;
        width: 450px;
        height: 298px;
        margin: 5px auto;
        z-index: 2;       
    }

    .wrapper{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/wrapper-hint.png);
        z-index: 2;
        pointer-events: none;       
    }

    .header{
        width: 447px;
        height: 45px;
        margin: 0 auto;
        background-image: url(~@/assets/images/header-hint.png);
    }

    .enter-view ul{
        display: flex;
        padding: 69px 50px 0;
        justify-content: space-between;
    }

    .u-btn.leader{
        width: 162px;
        height: 96px;
        background-image: url(../../assets/images/icon-leader.png);
    }

    .u-btn.team-member{
        width: 162px;
        height: 96px;
        background-image: url(../../assets/images/icon-member.png);
    }
    
    .enter-view p{
        font-size: 18px;
        color: #820000;
        margin-top: 18px;
        text-align: center;
    }    
</style>

<style>
    .leader-form .el-dialog__header{
        height: 0;
        padding: 0;
    }

    .leader-form .el-dialog__title{
        font-size: 0;
        color: transparent;
    }

    .leader-form .el-dialog__body{
        padding: 0;
    }

    .leader-form .el-dialog__headerbtn{
        /* display: none; */
    }
</style>


// WEBPACK FOOTER //
// src/components/entranceModal/entranceModal.vue